
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/billing-topup",
      function () {
        return require("private-next-pages/portal/billing-topup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/billing-topup"])
      });
    }
  